export const DATA_SOURCE_TYPE_PREFIX = 'DataSource';
